export default __webpack_public_path__ + "static/media/fish.b34f1398.svg";